import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { WhyDifferent } from './components/WhyDifferent';
import { HowItWorks } from './components/HowItWorks';
import { ForWho } from './components/ForWho';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { PIXEL_ID } from './data/constants';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}
export function App() {
  useEffect(() => {
    try {
      if (window.fbq) return;
      const pixel = ((...args: unknown[]) => {
        if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
      }) as PixelFunction;
      pixel.queue = [];
      pixel.push = pixel;
      pixel.loaded = true;
      pixel.version = '2.0';
      window.fbq = pixel;
      window._fbq = pixel;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript?.parentNode) firstScript.parentNode.insertBefore(script, firstScript);else document.head.appendChild(script);
      pixel('init', PIXEL_ID);
      pixel('track', 'PageView');
    } catch {
      /* Pixel loading must never interrupt the page render. */
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="36hwf6uoms18">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="35yq6nee9s31" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-charcoal" data-id="element-2" data-mp="d3mlpfjtr3m9">
        <main data-id="element-3" data-mp="85uktw17c75x">
          <Hero data-id="element-4" data-mp="85bap1hsmn2g" />
          <ProblemSection data-id="element-5" data-mp="86w7kxrkyi3h" />
          <WhatYouGet data-id="element-6" data-mp="83i3nl39q0tx" />
          <Bonuses data-id="element-7" data-mp="3glea6jyr55fp" />
          <WhyDifferent data-id="element-8" data-mp="3gkuy3jvs9b9l" />
          <HowItWorks data-id="element-9" data-mp="3gm66jx06b771" />
          <ForWho data-id="element-10" data-mp="3gja6a20us6ff" />
          <Offer data-id="element-11" data-mp="3bmbe3p0r29jv" />
          <Guarantee data-id="element-12" data-mp="3bmtjbb5e3y3x" />
          <Testimonials data-id="element-13" data-mp="3bncodr9xys0j" />
          <FAQ data-id="element-14" data-mp="3bo4n3ayu55v1" />
          <FinalCTA data-id="element-15" data-mp="3bkgr855x47d5" />
        </main>
        <Footer data-id="element-16" data-mp="3qbpq74vpn52y" />
        <PurchaseToast data-id="element-17" data-mp="3qc950cq2ddcr" />
      </div>
    </>;
}